import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components';
import { CalendarIcon } from '@rsos/base-assets/icons';
import { Box, Button } from '@rsos/base-components';

export const CalendarContainer = styled(Box)`
  /* The "Input" and the Absolute "Calendar" are siblings rather than parent-child */
  display: block;

  .react-datepicker {
    border-color: ${({ theme }) => theme.colors.lightLineDivider};

    &-wrapper {
      width: 100%;
    }

    &__day-name {
      color: ${({ theme }) => theme.colors.secondaryText};
      width: 30px;
      margin: 0px;
    }

    &__day-names {
      margin-bottom: 0px;
    }

    &__header {
      background-color: ${({ theme }) => theme.colors.background};
      border: none;
      padding-bottom: 0px;
    }

    &__month {
      margin-top: 2px;
    }

    &__month-container {
      background-color: ${({ theme }) => theme.colors.background};
      border: none;

      border-radius: 0.3em;
    }

    &__day {
      color: ${({ theme }) => theme.colors.secondaryText};
      width: 30px;
      height: 30px;
      margin: 0;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      font-weight: 400;

      &--outside-month {
        color: ${({ theme }) => theme.colors.heavyLineOutline};
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.foreground} !important;
      }

      &:focus {
        outline: 1px solid ${({ theme }) => theme.colors.primaryBase};
      }

      &--selected {
        background-color: ${({ theme }) => theme.colors.primaryBaseC2};
        color: ${({ theme }) => theme.colors.background};

        &:hover {
          background-color: ${({ theme }) =>
            theme.colors.primaryBaseC2} !important;
        }
      }

      &--keyboard-selected {
        background-color: ${({ theme }) => theme.colors.foreground};
      }
    }
  }

  h2 {
    color: ${({ theme }) => theme.colors.secondaryText};
    font-weight: normal;
    padding-bottom: 12px;
  }
`;

export const MonthButton = styled(Button).attrs({
  btnType: 'tertiary',
  noMargin: true,
})`
  width: 28px;
  height: 28px;
  padding: 0px;
`;

export const CustomInput = styled.input`
  background-color: transparent;
  border: none;
  padding: 0px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primaryText};
  &:focus {
    outline: none;
  }
  width: 100%;
`;

export const StyledCalendarIcon = styled(CalendarIcon).attrs({
  height: '14px',
  width: '13px',
  color: 'secondaryLink',
})`
  cursor: text;
`;

export const InputContainer = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  align: 'center',
  backgroundColor: 'background',
  border: '1px solid',
  borderColor: 'heavyLineOutline',
  paddingLeft: '10px',
  paddingRight: '7px',
  borderRadius: '4px',
  height: '35px',
})`
  &:focus-within {
    outline: 1px solid ${({ theme }) => theme.colors.primaryBase};

    & ${StyledCalendarIcon} {
      color: ${({ theme }) => theme.colors.primaryBase};
    }
  }
`;
